import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=13bb746e&scoped=true&"
import script from "./contact-form.ts?vue&type=script&lang=ts&"
export * from "./contact-form.ts?vue&type=script&lang=ts&"
import style0 from "./contact-form.scss?vue&type=style&index=0&id=13bb746e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb746e",
  null
  
)

export default component.exports